import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../../components/ui/button";
import Common from "../../../../helper/common";
import { FormikInput } from "../../../../components/formik-components";
import { respEnum, DoubleMin, DoubleMax } from "../../../../constants/appConstant";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";

const FormikInitialValues = {};
const formikValidation = yup.object({
    name: yup.string().required("Name is required"),
    code: yup.string().required("Code is required"),
    utcDiff: yup.number().min(DoubleMin).max(DoubleMax).required("Utc Diff is Required"),
});

const AddCountries = ({ id, onClose, open, setOpen }) => {
    const formikRef = useRef();
    const dialogRef = useRef();
    const navigate = useNavigate();
    const [isFormikInitialized, setIsFormikInitialized] = useState(false);

    useEffect(() => {
        setIsFormikInitialized(open);
    }, [open]);

    const onSubmitData = async (d, action) => {
        
        let data = {
            ...d,
            id,
        };
        let response = await Common.ApiService.getInstance().request(
            "AddUpdateCountry",
            data,
            "POST"
        );
        action.setSubmitting(false);
        if (response.status === respEnum.Success) {
            onClose(response.data);
            setOpen(false);
            if (!onClose) {
                navigate("/app/countries", { replace: true });
            }
        }
    };

    const getDataInfo = async () => {
        
        let response = await Common.ApiService.getInstance().request(
            `GetCountries?id=${id}`
        );
        if (response.status === respEnum.Success && response.data.length > 0) {
            formikRef.current.setValues(response.data[0]);
        }
    };

    useEffect(() => {
        if (id) {
            getDataInfo();
        }
    }, [id]);

    return (
        <div>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogTrigger asChild>
                    {/*<Button*/}
                    {/*    style={{ marginTop: "-15px" }}*/}
                    {/*    size="icon"*/}
                    {/*    variant="ghost"*/}
                    {/*    className="group p-1 "*/}
                    {/*>*/}
                    {/*    <Icon icon="heroicons:plus-20-solid" className=" h-6 w-6 " />*/}
                    {/*</Button>*/}
                    <Button
                        //onClick={() => setOpen(true)}
                        size="sm"
                        variant="primary"
                        className="flex items-center gap-2"
                    >
                        <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
                        Add Country
                    </Button>
                </DialogTrigger>
                <DialogContent ref={dialogRef}>
                    <DialogHeader>
                        <DialogTitle className="text-base font-medium ">
                            {!id ? "Add" : "Update"} Countries
                        </DialogTitle>
                    </DialogHeader>

                    <div className="text-sm text-default-500  space-y-2">
                        <Formik
                            innerRef={formikRef}
                            onSubmit={onSubmitData}
                            initialValues={FormikInitialValues}
                            validationSchema={formikValidation}
                            validateOnChange={false}
                            validateOnBlur={false}
                        >
                            {(formikProps) => (
                                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                                    <div className="col-span-1">
                                        <div className="md:grid md:grid-cols-1  gap-6 mt-6 space-y-6 md:space-y-0">
                                            <div className="flex flex-col gap-2">
                                                <FormikInput
                                                    formikProps={formikProps}
                                                    name={"name"}
                                                    label={"Name"}
                                                    placeholder={"Name"}
                                                    maxLength="20"
                                                />
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <FormikInput
                                                    formikProps={formikProps}
                                                    name={"code"}
                                                    label={"Code"}
                                                    placeholder={"Code"}
                                                    maxLength="10"
                                                />
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <FormikInput
                                                    formikProps={formikProps}
                                                    name={"utcDiff"}
                                                    label={"Utc Diff"}
                                                    placeholder={"Utc Diff"}
                                                    type={"number"}
                                                    max={DoubleMax}
                                                    min={DoubleMin}
                                                    onChange={(value) => {
                                                    if (value < DoubleMin && value != "") {
                                                            formikProps.setFieldValue("utcDiff", DoubleMin);
                                                    } else if (value > DoubleMax) {
                                                       // Common.SweetAlert.alert(`Utc Diff cannot be greater than ${DoubleMax}`, "error", "error");
                                                       Common.showToast(`Utc Diff cannot be greater than ${DoubleMax}`);
                                                            formikProps.setFieldValue("utcDiff", "");
                                                        } else {
                                                            formikProps.setFieldValue("utcDiff", value);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Formik>
                    </div>
                    <DialogFooter className="mt-8 gap-2">
                        <DialogClose asChild>
                            <Button type="button" variant="outline">
                                Close
                            </Button>
                        </DialogClose>

                        {isFormikInitialized && formikRef.current && (
                            <Button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    formikRef.current?.handleSubmit();
                                }}
                            >
                                {formikRef.current.isSubmitting
                                    ? "Saving..."
                                    : !id
                                        ? "Add"
                                        : "Update"}
                            </Button>
                        )}
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default AddCountries;
